import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { useMemo } from 'react';

import { AssociateNotice } from './AssociateNotice';
import { NoOrganizationNotice } from './NoOrganizationNotice';
import { useFetchAndEnsureProfile } from './useFetchAndEnsureProfile';
import { useSetDefaultTimeZone } from './useSetDefaultTimeZone';
import { Roles } from './useUserRoles';
import { useAppSelector } from 'src/app/store/hooks';
import { Logo } from 'src/common/Logo';

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { isLoading: isLoadingProfile } = useFetchAndEnsureProfile();
  const { isLoading: isLoadingTimezone } = useSetDefaultTimeZone();

  // load profile from store to ensure it's set
  const profile = useAppSelector((state) => state.auth.profile);
  const currentOrganizationId = useAppSelector(
    (state) => state.auth.currentOrganizationId
  );

  const isAssociate = useMemo(() => {
    const organizationMembership = profile?.memberships.find(
      (membership) => membership.organization.id === currentOrganizationId
    );

    return organizationMembership?.role === Roles.Associate;
  }, [currentOrganizationId, profile]);

  if (isLoadingProfile || isLoadingTimezone) {
    return (
      <div
        className="flex h-[100vh] w-[100vw] flex-col items-center justify-center gap-2"
        data-testid="loading"
      >
        <Logo />
        <LoadingIndicator />
      </div>
    );
  }

  if (profile && profile.memberships.length === 0) {
    return <NoOrganizationNotice profile={profile} />;
  }

  if (isAssociate) {
    return <AssociateNotice profile={profile} />;
  }

  return profile ? children : null;
}
